import {MutationTree} from "vuex";
import {ProcessProfileState, ProcessProfile} from "./model";

const mutations: MutationTree<ProcessProfileState> = {
  setProcessProfiles(state, processProfiles: ProcessProfile[]) {
    state.processProfiles = processProfiles;
  },
  addProcessProfile(state, processProfile: ProcessProfile) {
    state.processProfiles.push(processProfile);
  },
  updateProcessProfile(state, processProfile: ProcessProfile) {
    const c = state.processProfiles.find(c => c.id === processProfile.id);
    Object.assign(c, processProfile);
  },
  deleteProcessProfile(state, id: string) {
    state.processProfiles = state.processProfiles.filter(processProfile => processProfile.id !== id);
  }
}

export default mutations;
